export const categories = [
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-movie-line',
    description: '最新院线大片、经典电影回顾，高清画质带来沉浸式观影体验',
    color: 'primary',
    count: 2836,
  },
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    icon: 'ri-tv-line',
    description: '热门国产剧、海外剧集，每日更新，追剧不间断',
    color: 'accent',
    count: 4521,
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-emotion-laugh-line',
    description: '热播综艺节目、真人秀、脱口秀，欢乐无限放松心情',
    color: 'secondary',
    count: 1853,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-rocket-line',
    description: '日漫、国漫、美漫全收录，二次元世界等你来探索',
    color: 'primary',
    count: 3214,
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-earth-line',
    description: '自然、历史、科技纪录片，足不出户看遍世界精彩',
    color: 'accent',
    count: 1426,
  },
];

export const getCategoryBySlug = (slug: string) => categories.find((c) => c.slug === slug);